import React, { useState, useRef } from "react";
import { TopButs } from "./TopButs"
import { FormBox } from "./FormBox"
import { MaterialTableBox } from "./materialTableBox"
import { ItemTableBox } from "./itemTableBox"
import { FixedBottom } from "./FixedBottom"
import { MaterialModal } from "./materialModal"
import { ItemModal } from "./itemModal"
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { useAppointmentDetailsModel } from "./appointmentDetailsModels";
import { HistoryModel } from "@/views/historyModel";
import { ConsumeHistoryModel } from "@/views/commonModule/consumeHistoryModel"
import { RepairHistoryModel } from "@/views/commonModule/repairHistoryModel"
import useGlobalModel from "@/model/globalModel";



export const AppointmentDetails = () => {
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    const IFormRef = useRef<IYhFormRef>();
    const {
        historyRow,
        historyVisible, setHistoryVisible,
        consumeHistoryModel,
        consumeHistoryVisible, setConsumeHistoryVisible,
        repairHistoryVisible, setRepairHistoryVisible,
        repairHistoryModel, setRepairHistoryModel
    } = useAppointmentDetailsModel()
    const { user: { roles } } = useGlobalModel();

    return (
        <>
            {/* <TopButs {...detailsInfo} IFormRef={IFormRef} /> */}
            <FormBox {...detailsInfo} IFormRef={IFormRef} />
            <ItemTableBox {...detailsInfo} IFormRef={IFormRef} />
            <MaterialTableBox {...detailsInfo} IFormRef={IFormRef} />
            {!roles.includes('hd-b') && <FixedBottom {...detailsInfo} />}
            <MaterialModal {...detailsInfo} />
            <ItemModal {...detailsInfo} />
            <HistoryModel
                visible={historyVisible}
                materialCode={historyRow.materialCode as string}
                materialName={historyRow.materialName as string}
                onCancel={() => setHistoryVisible(false)}
            />
            <ConsumeHistoryModel
                visible={consumeHistoryVisible}
                name={consumeHistoryModel.customerName}
                onCancel={() => setConsumeHistoryVisible(false)}
            />
            <RepairHistoryModel
                visible={repairHistoryVisible}
                licensePlate={repairHistoryModel.licensePlate}
                onCancel={() => setRepairHistoryVisible(false)}
            />
        </>
    )
}